import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import useGetBookingLotById from './useGetBookingLotById'
import useGetCarpayLotById from './useGetCarpayLotById'
import { lotRoute, lotRouteNotFound } from '@views/Lot/route'
import carpayHomeRoute from '@views/Carpay/Home/route.const'

const useCarpayBookingLotActivated = (lotId?: string | null) => {
    const history = useHistory()

    const [carpayStatus, setCarpayStatus] = useState<null | boolean>(null)
    const [bookingStatus, setBookingStatus] = useState<null | boolean>(null)

    const { loading: carpayLotLoading } = useGetCarpayLotById({
        skip: !lotId,
        variables: { lot_id: lotId! },
        onCompleted: () => setCarpayStatus(true),
        onError: () => setCarpayStatus(false)
    })

    const { loading: bookingLotLoading } = useGetBookingLotById({
        skip: !lotId,
        variables: { lot_id: lotId! },
        onCompleted: () => setBookingStatus(true),
        onError: () => setBookingStatus(false)
    })

    useEffect(() => {
        if (carpayLotLoading || bookingLotLoading) return
        if (carpayStatus === null || bookingStatus === null) return

        if (carpayStatus && !bookingStatus) {
            history.replace(carpayHomeRoute)
        } else if (!carpayStatus && bookingStatus) {
            if (lotId) history.replace(lotRoute(lotId))
        } else if (!carpayStatus && !bookingStatus) {
            history.replace(lotRouteNotFound())
        }
    }, [carpayLotLoading, bookingLotLoading, carpayStatus, bookingStatus, history, lotId])

    return [carpayLotLoading || bookingLotLoading] as const
}

export default useCarpayBookingLotActivated
